import React from 'react';
import { Box } from '@mui/material';

import { BodyMedium } from '../../styles';
import { ModalDialog } from '../modal-dialog/ModalDialog';

export type ConfirmationDialogProps = {
    isOpen: boolean;
    title: string;
    message: string;
    okButton: string;
    onClose: () => void;
    onSubmit: () => void;
};
export const ConfirmationDialog = ({
    isOpen,
    title,
    message,
    okButton,
    onClose,
    onSubmit
}: ConfirmationDialogProps) => {
    return (
        <>
            <ModalDialog
                open={isOpen}
                title={title}
                showFullTitle
                onClose={onClose}
                submitText={okButton}
                onSubmit={onSubmit}
                modalContentStyle={{ maxWidth: '66%' }}
            >
                <Box sx={{ mt: 2, mb: 2 }}>
                    {message.split('\n').map((line, index) => (
                        <BodyMedium key={index}>{line}</BodyMedium>
                    ))}
                </Box>
            </ModalDialog>
        </>
    );
};

